import { render, staticRenderFns } from "./search-adverts-pagination.vue?vue&type=template&id=5e32f25d"
import script from "./search-adverts-pagination.vue?vue&type=script&lang=ts"
export * from "./search-adverts-pagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports